import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bff0fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "server-date"
}
const _hoisted_2 = { class: "buttons" }

export function render(_ctx, _cache) {
  const _component_AccountInfoPanel = _resolveComponent("AccountInfoPanel")
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_NavigationBar = _resolveComponent("NavigationBar")
  const _component_AddEditInvestigationModal = _resolveComponent("AddEditInvestigationModal")
  const _component_AddEventModal = _resolveComponent("AddEventModal")
  const _component_AddEditMemberModal = _resolveComponent("AddEditMemberModal")
  const _component_InvestigationDetailsModal = _resolveComponent("InvestigationDetailsModal")
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isFixHeader ? 'fixed-header' : '')
    }, [
      _createVNode(_component_PageHeader, { appName: 'TRUST ADMIN' }, _createSlots({ _: 2 }, [
        (_ctx.showRHSHeader)
          ? {
              name: "rhs-header",
              fn: _withCtx(() => [
                _createVNode(_component_AccountInfoPanel)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      (this.env.length > 0 && !_ctx.isToday && _ctx.showDateTip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$formatDate(_ctx.displayDate)) + " ", 1),
            _createElementVNode("i", {
              class: "fal fa-times ml-3",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.showDateTip = false)),
              style: {"cursor":"pointer"}
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_NavigationBar, {
        navItems:  _ctx.errorLoadingData || _ctx.loadingData ? [] : _ctx.navItems
      }, _createSlots({ _: 2 }, [
        (!_ctx.errorLoadingData && !_ctx.loadingData)
          ? {
              name: "right-side-buttons",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "btn sml btn-outline",
                    onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.openAddEditInvestigationModal()), ["prevent","stop"]))
                  }, " Add investigation/routine ")
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["navItems"])
    ], 2),
    (_ctx.showAddEditInvestigationModal)
      ? (_openBlock(), _createBlock(_component_AddEditInvestigationModal, {
          key: 0,
          investigation: _ctx.selectedInvestigation,
          isFromRoutine: _ctx.isFromRoutine,
          routineId: _ctx.routineId,
          onCloseAddEditInvestigationModal: _cache[2] || (_cache[2] = $event => (_ctx.closeAddEditInvestigationModal()))
        }, null, 8, ["investigation", "isFromRoutine", "routineId"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEditEventModal)
      ? (_openBlock(), _createBlock(_component_AddEventModal, {
          key: 1,
          eventFormData: _ctx.selectedEventFormData,
          onCloseAddEventModal: _cache[3] || (_cache[3] = $event => (_ctx.closeAddEditEventModalBox()))
        }, null, 8, ["eventFormData"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEditMemberModal)
      ? (_openBlock(), _createBlock(_component_AddEditMemberModal, {
          key: 2,
          teamMember: _ctx.selectedTrustTeamMember,
          onCloseAddEditMemberModal: _cache[4] || (_cache[4] = $event => (_ctx.closeAddEditMemberModal()))
        }, null, 8, ["teamMember"]))
      : _createCommentVNode("", true),
    (_ctx.showInvestigationDetailsModal)
      ? (_openBlock(), _createBlock(_component_InvestigationDetailsModal, {
          key: 3,
          investigation: _ctx.selectedInvestigation,
          onCloseModal: _cache[5] || (_cache[5] = $event => (_ctx.closeInvestigationDetailsModal()))
        }, null, 8, ["investigation"]))
      : _createCommentVNode("", true),
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 4 }))
      : (_ctx.errorLoadingData)
        ? (_openBlock(), _createBlock(_component_ErrorIndicator, { key: 5 }))
        : (!_ctx.loadingData && !_ctx.errorLoadingData)
          ? (_openBlock(), _createBlock(_component_router_view, {
              key: 6,
              class: _normalizeClass(_ctx.isFixHeader? 'content-container' : '')
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
  ], 64))
}